import { useMemo } from 'react';
import { getBrand, type BrandContext } from '../config/brand.config';

export function useBrand(): BrandContext {
  return useMemo(() => getBrand(), []);
}
